import { frontendURL } from '../../../helper/URLHelper';
const SettingsWrapper = () => import('../settings/Wrapper.vue');
const TemplateView = () => import('./components/TemplateView.vue');
const FlowView = () => import('./components/FlowView.vue');

export const  routes = [
    {
      path: frontendURL('accounts/:accountId/builders'),
      component: TemplateView,
      children: [
        {
          path: '',
          redirect: 'template',
        },
        {
          path: 'template',
          name: 'template_builders',
          meta: {
            permissions: ['administrator'],
          },
          component: TemplateView,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/builders'),
      children: [
        {
          path: 'flow',
          name: 'flow_builders',
          meta: {
            permissions: ['administrator'],
          },
          component: FlowView,
        },
      ],
    },
  ];
